import { RestrictedTeamViewChat } from '../RestrictedTeamViewChat/index';
import { useRestrictedTeamView } from '../../../providers/RestrictedTeamViewProvider/context';
import { useSession } from '@lendi/lala-react';
import { useFlags } from '@lendi/launchdarkly';
import React from 'react';
import { useActivateUserGroup } from '../../../hooks/useActivateUserGroup';
import { ChatDataExposer } from '../../../providers/ChatExposureProvider/ChatDataExposer';
import { ChatProvider, ConversationProvider } from '../../../twilio';
import { ChatPanels } from '../../../types';
import CommPanelLoader from '../../Loader';
import { ChatHeader } from '../../ChatHeader';
import TwilioChatComponent from '../TwilioChatComponent';
import { StatusBar } from '../../StatusBar';
import { analytics, EventCategory } from '../../../analytics';
import { useBootstrappedChatState } from '../../../providers/ChatBootstrapperProvider/context';
import ErrorComponent from '../ErrorComponent';
export var CurrentThread = function (_a) {
    var migratedToConversation = _a.migratedToConversation, channelId = _a.channelId, openChat = _a.openChat, userType = _a.userType, teamMember = _a.teamMember, setActivePanel = _a.setActivePanel, onClose = _a.onClose;
    var errorState = useBootstrappedChatState().errorState;
    var session = useSession();
    var _b = useActivateUserGroup(openChat, session, channelId), identity = _b[0], accessToken = _b[1];
    var ChatProviderComponent = migratedToConversation ? ConversationProvider : ChatProvider;
    var enableHistoricalThreads = useFlags().enableHistoricalThreads;
    var isTeamView = userType === 'broker';
    var _c = useRestrictedTeamView(), teamRestrictedView = _c.teamRestrictedView, restrictedViewLoading = _c.restrictedViewLoading, restrictedViewResponse = _c.restrictedViewResponse, fetchNextPage = _c.fetchNextPage;
    var onShowHistory = function () {
        setActivePanel(ChatPanels.Threads);
        analytics({
            event_name: 'Menu Item Clicked',
            category: EventCategory.CHAT,
            menuName: 'Kebab menu',
            text: 'History',
        });
    };
    if (errorState) {
        return React.createElement(ErrorComponent, null);
    }
    if (!channelId || !identity || !accessToken || restrictedViewLoading) {
        return React.createElement(CommPanelLoader, null);
    }
    if (teamRestrictedView) {
        return (React.createElement(React.Fragment, null,
            enableHistoricalThreads && (React.createElement(ChatHeader, { activePanel: ChatPanels.CurrentThread, onShowHistory: onShowHistory, showBackArrow: !isTeamView, teamRestrictedViewProps: {
                    teamRestrictedView: teamRestrictedView,
                    teamRestrictedViewParticipantsCount: restrictedViewResponse === null || restrictedViewResponse === void 0 ? void 0 : restrictedViewResponse.participantsCount,
                }, onClose: onClose })),
            React.createElement(RestrictedTeamViewChat, { restrictedViewResponse: restrictedViewResponse, fetchNextPage: fetchNextPage, restrictedViewLoading: restrictedViewLoading })));
    }
    return (React.createElement(ChatProviderComponent, { key: channelId, session: session, channelId: channelId, accessToken: accessToken, identity: identity, userType: userType },
        React.createElement(ChatDataExposer, { userType: userType },
            enableHistoricalThreads && (React.createElement(React.Fragment, null,
                React.createElement(ChatHeader, { activePanel: ChatPanels.CurrentThread, onShowHistory: onShowHistory, showBackArrow: !isTeamView }),
                React.createElement(StatusBar, { showThreadsPanel: function () {
                        analytics({
                            event_name: 'Link Clicked',
                            category: EventCategory.CHAT,
                            text: 'Click here',
                        });
                        setActivePanel(ChatPanels.Threads);
                    }, currentThread: channelId }))),
            openChat && React.createElement(TwilioChatComponent, { userType: userType, teamMember: teamMember }))));
};
//# sourceMappingURL=index.js.map